import { createStyleSheet } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  cursor: {
    width: rw(2),
    borderRadius: rw(24),
    backgroundColor: theme.COLOR_ICON_BRAND,
  },
  cursorHidden: {
    width: rw(2),
  },
}))
